var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusaiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1150px",
    height: "500px",
    viewBox: "0 0 1423 493",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(279.000000, 0.000000)",
    fill: "#3153A9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.962525,418 L335.298508,314.92929 L491.399571,314.92929 L525.801111,418 L606.086124,418 L459.707893,0 L366.853004,0 L220.677512,418 L300.962525,418 Z M471.101092,254.106919 L355.561828,254.106919 L411.658529,85.7226563 L414.902368,85.7226563 L471.101092,254.106919 Z",
    id: "A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "23.3335275 254.571429 460.003828 254.571429 460.003828 314.285714 1.71849725e-14 314.285714"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "87.0277512 207.804828 146.082297 150.857143 146.082297 418 87.0277512 418"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(727.318660, 284.428571) scale(-1, 1) translate(-727.318660, -284.428571) ",
    points: "686.897608 207.804828 767.739713 150.857143 767.739713 418 686.897608 418"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusaiLogo);
export default __webpack_public_path__ + "static/media/plusai_logo.27d5e406997bdf80cd60ca22828e3913.svg";
export { ForwardRef as ReactComponent };